import CustomPacingScheduleProvider from '../CustomPacingScheduleProvider/CustomPacingScheduleProvider';
import CustomPacingStepper from '../CustomPacingStepper/CustomPacingStepper';

type Props = {
  lineItemIdList: string[];
  onClose: () => void;
};

const CustomPacingScheduleContent = ({ lineItemIdList, onClose }: Props): React.JSX.Element => {
  return (
    <CustomPacingScheduleProvider onClose={onClose}>
      <CustomPacingStepper lineItemIdList={lineItemIdList} />
    </CustomPacingScheduleProvider>
  );
};

export default CustomPacingScheduleContent;
